export function translateMissKeyboard (text) {
  const eng = "f  ,  d  u  l  t  `  ;  p  b  q  r  k  v  y  j  g  h  c  n  e  a  [  w  x  i  o  ]  s  m  '  .  z  {  }  \"  >  <".split(/ +/g);
  const rus = "а  б  в  г  д  е  ё  ж  з  и  й  к  л  м  н  о  п  р  с  т  у  ф  х  ц  ч  ш  щ  ъ  ы  ь  э  ю  я  х  ъ  э  ю  б".split(/ +/g);

  for (let x = 0; x < eng.length; x++) {
    text = text.split(eng[x]).join(rus[x]);
  }
  return text;
}



// WEBPACK FOOTER //
// ./src/utils/translate.js